import isEmpty from 'lodash/isEmpty';
import { FC } from 'react';

import { useGetFileSummaryNewUi } from '../../FileSummaryNewUi.hooks';

const SummaryRefundHistory: FC = () => {
  const { data } = useGetFileSummaryNewUi();
  const { commercialGesture, commercialSolution, refund } = data?.fullSummary ?? {};

  if (
    isEmpty(commercialSolution) &&
    isEmpty(refund?.refundedAmount?.amount) &&
    isEmpty(commercialGesture)
  ) {
    return null;
  }

  // POC : section remboursements non portée depuis Control pour l'instant.
  return null;
};

export default SummaryRefundHistory;
